import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { NotPersistAction } from "store/actions";
import C from "Constants";
import { useCustomHistory } from "hooks";
import { useQueryParam } from "modules/dine-in/hooks";
import useEventTracker from "hooks/useEventTracker";
import { PageHeaderV2 } from "components/PageHeader";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";
import GoogleReview from "components/google-reviews"
import Completion from "icons/completion";

function OrderPlaced(props) {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const router = useCustomHistory();
  const queryParam = useQueryParam();
  const [shopUrl, setShopUrl] = useState(null);
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  useEventTracker({ name: "ORDER_PLACED", shouldLog: true, orderType: null });
  useEventTracker({ name: "ORDER_PLACED", shouldLog: true, orderType });

  const share = (DOMAIN_NAME, url) => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    const message = `Hi, I have just ordered from ${brandInfo?.brand?.brandName} You can also avail BIG discounts as soon as you place your first order. ${url} `;
    window.open(`https://wa.me/?text=${message}`, "_blank");
  };

  const goToDineHomePage = (url) => {
    history.push({
      pathname: url,
      search: queryParam,
    });
  };

  const shareOnWhatsapp = () => {
    if (DomainType === C.TEMPORARAY_DOMAIN) {
      const DOMAIN_NAME = params?.domainName;
      let url = C.PAYMENT_REDIRECT_URL + DOMAIN_NAME;
      share(DOMAIN_NAME, url);
      if (DOMAIN_NAME) {
        if (orderType?.serviceType === C.SERVICE_TYPE.DINE_IN) {
          goToDineHomePage(`/${DOMAIN_NAME}/dine-in`);
        } else {
          history.push(`/${DOMAIN_NAME}/`);
        }
      }
    } else {
      let url = C.PAYMENT_REDIRECT_URL || "";
      share(brandInfo.brand?.brandName, url);
      if (orderType?.serviceType === C.SERVICE_TYPE.DINE_IN) {
        goToDineHomePage(`/dine-in`);
      } else {
        history.push(`/`);
      }
    }
  };

  useEffect(() => {
    if (brandInfo?.storeFrontURL) {
      setShopUrl(brandInfo.storeFrontURL);
    }
  }, []);

  const goBack = () => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    if (props?.gotoHomePage) {
      props.gotoHomePage();
    } else {
      router("/", `/${params?.domainName}`, DomainType);
    }
  };

  return (
    <div className="relative flex flex-col gap-8 items-center">
      <PageHeaderV2
        pageTitle={"Confirmation"}
        authClick={props?.goToLogin}
        userClick={props?.goToSettings}
        onGoBack={goBack}
        containerStyleProps={{
          className: "relative",
        }}
        hideAuth={!props?.goToLogin && !props?.goToSettings}
      />
      <div className="flex-1 flex flex-col gap-6 items-center justify-center  w-full">
       <Completion />

        <TranslationText
          text={"Thank you for your Order"}
          className="text-24x font-bold text-shadow-forge-900"
        />
        {props?.showGoogleReview ? <GoogleReview /> : <></>}
      </div>
      <div className="w-full bg-dark-blue-100 p-6 flex flex-col gap-2">
        <CustomButton onClick={props?.trackOrder}>
          <TranslationText text={"Track Order"} />
        </CustomButton>
        {shopUrl && (
          <CustomButton outline onClick={shareOnWhatsapp}>
            <TranslationText text={"Share with Friends"} />
          </CustomButton>
        )}
      </div>
    </div>
  );
}

export default OrderPlaced;
